import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MaterialFileInputModule } from 'ngx-material-file-input';

import { DireccionGeograficaFormComponent } from './direcciones-geografica/direccion-geografica-form/direccion-geografica-form.component';

import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CheckListTooltipsFormComponent } from './check-list-tooltips/check-list-tooltips-form/check-list-tooltips-form.component';
import { ActividadesMiEmpresaFormComponent } from './datos-mi-empresa/actividades-mi-empresa-form/actividades-mi-empresa-form.component';
import { InformacionFormComponent } from './datos-mi-empresa/informacion-form/informacion-mi-empresa-form.component';
import { IntegrantesFormComponent } from './datos-mi-empresa/integrantes-form/integrantes-form.component';
import {
  CheckListFormComponent,
  ChipListFormComponent
} from './registro-personas-empresas-lib.component';
import { CampoPlusFormComponent } from './util/campo-plus/campo-plus-form/campo-plus-form.component';

@NgModule({
  declarations: [
    ActividadesMiEmpresaFormComponent,
    CampoPlusFormComponent,
    CheckListFormComponent,
    CheckListTooltipsFormComponent,
    ChipListFormComponent,
    DireccionGeograficaFormComponent,
    InformacionFormComponent,
    IntegrantesFormComponent
  ],
  imports: [
    // angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // material
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatStepperModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MaterialFileInputModule,
    MatRadioModule,
    MatChipsModule,

    // 3rd party
    FontAwesomeModule,
    MatTabsModule
  ],
  exports: [
    // material
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    ActividadesMiEmpresaFormComponent,
    InformacionFormComponent,
    IntegrantesFormComponent,
    DireccionGeograficaFormComponent,
    CampoPlusFormComponent,
    CheckListFormComponent,
    CheckListTooltipsFormComponent,
    ChipListFormComponent,
    FontAwesomeModule,
    MaterialFileInputModule,
    MatFormFieldModule,
    MatChipsModule
  ]
})
export class RegistroPersonasEmpresasLibModule {}
